import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { AppConfigurationDto, LandParcelDto, LandTitleDto, MeasureDto, MeasuringFactorDto, PurposeDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-land-parcellation-table',
  templateUrl: './land-parcellation-table.component.html',
  styleUrls: ['./land-parcellation-table.component.scss']
})
export class LandParcellationTableComponent implements OnChanges {

  @Input() selectedLandTitle: LandTitleDto;
  @Input() purposes: PurposeDto[];
  @Input() measures: MeasureDto[];
  @Input() landParcels: LandParcelDto[];
  @Input() measuringFactors: MeasuringFactorDto[];
  @Input() appConfigs: AppConfigurationDto[];

  @Output() emitEdit = new EventEmitter<LandParcelDto[]>();

  landParcelArrayForm: FormGroup;
  selectedMeasuringFactor: MeasuringFactorDto;

  selectedIndex = null;
  listView = false;
  gridView = true;
  appConfig: AppConfigurationDto;

  constructor(private fb: FormBuilder) {}

  ngOnChanges(): void {
  this.landParcelArrayForm = this.fb.group({LandParcels: this.fb.array([])});
  if(this.selectedLandTitle.landParcels != null && this.selectedLandTitle.landParcels.length) {
    this.setLandParcel(this.selectedLandTitle.landParcels);
  }
  this.appConfig = this.appConfigs.find(map => map.type === 'MyMap');
  }

  get landParcelFormArray() {
    return this.landParcelArrayForm.get('LandParcels') as FormArray;
  }


  setLandParcel(landParcels: LandParcelDto[]) {
   landParcels.forEach(land => {
      this.landParcelFormArray.push(this.fb.group({
        RowIdLinkage: land.RowIdLinkage,
        SectionName: land.SectionName,
        PurposeId: land.PurposeId,
        TotalArea: land.TotalArea,
        MeasureId: land.MeasureId,
        Cost: land.Cost,
        URLMap: land.URLMap,
        Hectare: land.Hectare,
        Acre: land.Acre,
        SqKM: land.SqKM,
        SqM: land.SqM,
        SqFeet: land.SqFeet,
        Roods: land.Roods,
        Perche: land.Perche,
        Plot: land.Plot,
        LandTitleId: land.LandTitleId,
        id: land.id
      }));
    });
  }

  addLandParcel(land: LandParcelDto) {
    this.landParcelFormArray.insert(0, this.fb.group({
      RowIdLinkage: land.RowIdLinkage,
      SectionName: land.SectionName,
      PurposeId: land.PurposeId,
      TotalArea: land.TotalArea,
      MeasureId: land.MeasureId,
      Cost: land.Cost,
      URLMap: land.URLMap,
      Hectare: land.Hectare,
      Acre: land.Acre,
      SqKM: land.SqKM,
      SqM: land.SqM,
      SqFeet: land.SqFeet,
      Roods: land.Roods,
      Perche: land.Perche,
      Plot: land.Plot,
      LandTitleId: [this.selectedLandTitle.id]
    }));

  }

  onList() {
    this.listView = true;
    this.gridView = false;
  }

  onGrid() {
    this.gridView = true;
    this.listView = false;
  }

   protected filterById = <T>(id: string, lookupId: string) =>
   (fieldName: T) => fieldName[lookupId] === id;



  onSelectedMeasure(id: string) {
  return this.measuringFactors.find(
    this.filterById<MeasuringFactorDto>(id, "MeasureId"),
  );
  }

  getPurposeName(id: string) {
  const found = this.purposes.find(
    this.filterById<PurposeDto>(id, "id"),
  );
   return found ? found.PurposeName : '';
  }

  getMeasureName(id: string) {
  const found = this.measures.find(
    this.filterById<MeasureDto>(id, "id"),
  );
   return found ? found.MeasureName : '';
  }


  onPopulateUrl(index: number) {
    const selectedValue: LandParcelDto = this.landParcelFormArray.at(index).value;

    const urlMap = selectedValue.RowIdLinkage + this.appConfig.rightvalue;
    this.landParcelFormArray.at(index).patchValue({URLMap: urlMap});

  }

  onDelete(index: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        // this.dispatchDelete.emit(id);
        this.landParcelFormArray.removeAt(index);
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }


  onEdit(value, index) {
    this.selectedIndex = index;
    value['index'] = index;
    this.emitEdit.emit(value);
  }



}
